<script setup lang="ts">
import { onMounted, useId } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { getConfigEntry } from '@/api/config';
import { ExpressLocation, useExpressCheckout } from '@/composables/useExpressCheckout';

const props = defineProps<{
  buttonHeight?: number;
  trackingEventLocation: ExpressLocation;
}>();

const router = useRouter();
const store = useStore();
const { requestShopPayPayment } = useExpressCheckout(
  store,
  router,
  () => props.trackingEventLocation,
);

const containerId = useId();

onMounted(async () => {
  const shopifyConfig = getConfigEntry('shopify');
  window.ShopPay?.PaymentRequest.configure({
    shopId: shopifyConfig.shopId,
    clientId: shopifyConfig.clientId,
  });

  if (!window.ShopPay?.session) {
    await requestShopPayPayment();
  }
  window.ShopPay?.PaymentRequest.createButton().render(`#${containerId}`);
});
</script>

<template>
  <div :id="containerId" class="relative rounded-full z-0 h-12 w-full" />
</template>

<style>
shop-pay-payment-request-button {
  --shop-pay-button-width: 100%;
  --shop-pay-button-border-radius: 24px;
  --shop-pay-button-height: 48px;
}
</style>
